import { render, staticRenderFns } from "./ProductPreviewModal.vue?vue&type=template&id=06e47276&scoped=true"
import script from "./ProductPreviewModal.vue?vue&type=script&lang=ts"
export * from "./ProductPreviewModal.vue?vue&type=script&lang=ts"
function injectStyles (context) {
  
  var style0 = require("./ProductPreviewModal.vue?vue&type=style&index=0&id=06e47276&prod&lang=scss&scoped=true")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "06e47276",
  null
  ,true
)

export default component.exports